import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page37',
  templateUrl: './page37.component.html',
  styleUrls: ['./page37.component.css']
})
export class Page37Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
